import React from "react";
import { InputProps } from "./types";
import Input from "./input";

export const MobileNumberInput = (props: InputProps) => {
  const {
    name,
    label,
    cssName,
    labelCssName,
    fieldOptions = {},
    customValidationMessage,
    placeHolder,
    ...rest
  } = props

  return <Input
    name={name}
    cssName={cssName}
    label={label}
    labelCssName={labelCssName}
    fieldOptions = {fieldOptions}
    type="tel"
    customValidationMessage={customValidationMessage}
    placeHolder={placeHolder}
    {...rest} />
}

export default MobileNumberInput;
